var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top_home ihlp-width-100",attrs:{"id":"container"}},[_c('div',{staticClass:"main ihlp-width-100"},[_c('div',{staticClass:"layout-content ihlp-width-100"},[(_vm.isRouterAlive)?_c('router-view',{key:_vm.activeDate}):_vm._e()],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fbe238f8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/Layout_top_home.vue
// module id = null
// module chunks = 